import React, { Fragment, Component } from 'react';
import { Grid, withStyles } from '@material-ui/core';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Toastr, tools } from 'data/common';
import { bindActionCreators } from 'redux';
import Translator from 'translator';
import PropTypes from 'prop-types';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { FHEItemText, FHEButton } from 'data/components';
import { deleteConfigOverride } from '../../../data/Boxes/actions';
import getSelectors from '../selectors';

class ConfigOverride extends Component {
    static propTypes = {
        homeBoxMac: PropTypes.string.isRequired,
        configOverride: PropTypes.object,
        history: PropTypes.object.isRequired,
        deleteConfigOverrideRights: PropTypes.bool.isRequired,
        deleteConfigOverride: PropTypes.func.isRequired,
        classes: PropTypes.object.isRequired
    };

    static defaultProps = {
        configOverride: null
    };

    constructor(props) {
        super(props);
        this.state = {
            configOverrideLoading: false
        };
    }

    deleteConfigOverride = () => {
        const { deleteConfigOverride, homeBoxMac, history } = this.props;

        return Toastr.confirm(
            Translator.translate('generic.home.configOverride.deleteConfirmation', Translator.translate(`${history.environment}.centerName`)),
            Translator.translate('general.table.column.configOverride'),
            {
                onYes: () => {
                    deleteConfigOverride(homeBoxMac)
                        .then(() => {
                            Toastr.success(
                                Translator.translate('generic.home.configOverride.deleteSuccess'),
                                Translator.translate('general.table.column.configOverride')
                            );
                        })
                        .catch(() => {
                            Toastr.error(
                                Translator.translate('generic.home.configOverride.deleteError'),
                                Translator.translate('general.table.column.configOverride')
                            );
                        });
                }
            }
        );
    };

    displayConfigOverride(config) {
        const { classes } = this.props;
        return <pre className={classes.configOverride}>{JSON.stringify(config, null, 4)}</pre>;
    }

    renderConfigOverride() {
        const { classes, configOverride, deleteConfigOverrideRights } = this.props;
        const { configOverrideLoading } = this.state;
        return (
            <Fragment>
                <Grid container spacing={3} justify="center" alignItems="center">
                    <Grid container item sm={12} md={12} lg={12}>
                        <FHEItemText
                            className={classes.configOverrideItemText}
                            itemTitle=""
                            itemContent={
                                configOverride ? this.displayConfigOverride(configOverride) : Translator.translate('generic.home.configOverride.none')
                            }
                        />
                    </Grid>
                    {configOverride !== null && deleteConfigOverrideRights && (
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEButton
                                fullWidth
                                content={Translator.translate('generic.home.button.configOverrideButton')}
                                clickFunction={this.deleteConfigOverride}
                                loading={configOverrideLoading}
                            />
                        </Grid>
                    )}
                </Grid>
            </Fragment>
        );
    }
    render() {
        return this.renderConfigOverride();
    }
}

const styles = theme => ({
    configOverride: {
        background: theme.palette.colors.grey100,
        padding: 10,
        marginTop: 10
    },
    configOverrideItemText: {
        marginBottom: 0
    }
});

function mapStateToProps(state, props) {
    const { history, match } = props;
    const homeId = match.params.homeId;
    const selectors = getSelectors(history.environment);
    const profile = selectors.getProfile(state);
    const homeBox = selectors.getBoxByHomeId(state, homeId);
    return {
        homeId: parseInt(homeId),
        profile,
        homeBoxMac: homeBox.get('macAddress'),
        configOverride: homeBox.getIn(['configOverride'], null),
        deleteConfigOverrideRights: profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('deleteConfigOverride')
    };
}

export default withRouter(
    renderEnvComponent(
        'scenes/Home/components/ConfigOverride',
        connect(
            mapStateToProps,
            (dispatch, ownProps) =>
                bindActionCreators(
                    tools.mergePropsToAction(ownProps.history.environment, {
                        deleteConfigOverride
                    }),
                    dispatch
                )
        )(withStyles(styles, { withTheme: true })(ConfigOverride))
    )
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Home/components/ConfigOverride.js